(function () {
  'use strict';
  // Samsung Internet draws its own scroll control over bottom-fixed actions.
  if (/SamsungBrowser\//i.test(navigator.userAgent)) {
    document.documentElement.classList.add('fr-samsung-internet');
  }
  if (window.FRProductRefinement) {
    window.FRProductRefinement.boot();
    return;
  }
  var instances = new Map();
  function boot(scope) {
    (scope || document).querySelectorAll('.frp[data-frp-version="7.0"]').forEach(init);
  }
  function init(root) {
    if (instances.has(root.id)) return;
    var sid = root.dataset.sectionId;
    var controls = new AbortController();
    var options = { signal: controls.signal };
    var observers = [];
    var timers = [];
    var labels = (window.FRP || {})[sid] || {};
    var picker = root.querySelector('.frp__size-picker');
    var input = root.querySelector('[name="id"]');
    var form = root.querySelector('.frp__form');
    var atc = document.getElementById('frp-atc-' + sid);
    var sticky = document.getElementById('frp-sticky-' + sid);
    var stickyButton = document.getElementById('frp-sticky-btn-' + sid);
    var status = root.querySelector('.frp__purchase-status');
    var stack = root.querySelector('.frp__stack');
    var items = Array.from(root.querySelectorAll('.frp__stack-item'));
    var thumbs = Array.from(root.querySelectorAll('.frp__thumb'));
    var buttons = picker ? Array.from(picker.querySelectorAll('.frp__size-btn')) : [];
    var variants = [];
    try { variants = JSON.parse(document.getElementById('frp-vdata-' + sid).textContent); } catch (error) { return; }
    var current = variants.find(function (variant) { return input && String(variant.id) === input.value; });
    var active = 0;
    var pending = false;
    var succeeded = false;
    var frame = 0;
    var mobile = matchMedia('(max-width: 749px)');
    var reduced = matchMedia('(prefers-reduced-motion: reduce)');
    function sample(variant) { return /(?:^|[^0-9])(?:2\s*ml|5\s*ml)\b|sample|tester/i.test(variant.title); }
    function selectImage(index, move) {
      if (!items.length) return;
      active = Math.max(0, Math.min(index, items.length - 1));
      thumbs.forEach(function (button, i) {
        button.classList.toggle('is-active', i === active);
        button.setAttribute('aria-pressed', String(i === active));
      });
      if (move && stack && mobile.matches) stack.scrollTo({ left: items[active].offsetLeft - items[0].offsetLeft, behavior: reduced.matches ? 'instant' : 'smooth' });
      if (move && !mobile.matches) items[active].scrollIntoView({ block: 'nearest', behavior: reduced.matches ? 'instant' : 'smooth' });
      if (thumbs[active] && mobile.matches) {
        var rail = root.querySelector('.frp__thumbs');
        rail.scrollTop = Math.max(0, thumbs[active].offsetTop - rail.clientHeight / 2 + thumbs[active].clientHeight / 2);
      }
    }
    thumbs.forEach(function (button, index) { button.addEventListener('click', function () { selectImage(index, true); }, options); });
    if (stack) stack.addEventListener('scroll', function () {
      if (!mobile.matches || !stack.clientWidth) return;
      selectImage(Math.round(stack.scrollLeft / stack.clientWidth), false);
    }, { passive: true, signal: controls.signal });
    function updateSticky() {
      frame = 0;
      if (!sticky || !atc) return;
      var header = document.querySelector('.fr-mobile-header');
      var headerBottom = header && mobile.matches ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var main = atc.getBoundingClientRect();
      var blocked = document.body.classList.contains('fr-cart-open') || !!document.activeElement.closest('.fr-review-unit__form');
      var visible = main.bottom < headerBottom && !blocked;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      sticky.inert = !visible;
      document.body.classList.toggle('frp-has-sticky', visible);
      if (stickyButton && current) {
        stickyButton.disabled = pending || !current.available;
        stickyButton.textContent = pending ? labels.adding : (current.available ? labels.addToCart : labels.soldOut);
        stickyButton.setAttribute('aria-busy', String(pending));
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(updateSticky); }
    function selectVariant(variant, updateUrl, showMedia) {
      if (!variant) return;
      current = variant;
      if (input) input.value = String(variant.id);
      buttons.forEach(function (button) {
        var selected = String(variant.id) === button.dataset.variantId;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      if (atc) {
        atc.disabled = !variant.available;
        atc.classList.toggle('is-soldout', !variant.available);
        atc.textContent = variant.available ? labels.addToCart : labels.soldOut;
        atc.dataset.originalText = atc.textContent;
      }
      root.classList.toggle('is-sample', sample(variant));
      root.querySelectorAll('[data-frp-tester]').forEach(function (note) { note.hidden = sample(variant); });
      if (status) { status.textContent = ''; status.classList.remove('is-error'); }
      if (showMedia) {
        var mediaId = (variant.featured_media || variant.featured_image || {}).id;
        var mediaIndex = sample(variant) ? items.findIndex(function (item) { return String(mediaId) === item.dataset.mediaId; }) : 0;
        if (mediaIndex >= 0) selectImage(mediaIndex, mobile.matches);
      }
      if (updateUrl) {
        var url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);
      }
      updateSticky();
      document.dispatchEvent(new CustomEvent('frp:variant-change', { detail: { sid: sid, variant: variant } }));
    }
    function choose(button) {
      if (!button || pending || button.dataset.available === 'false') return;
      var variant = variants.find(function (item) { return String(item.id) === button.dataset.variantId; });
      selectVariant(variant, true, true);
    }
    if (picker) {
      picker.addEventListener('click', function (event) { choose(event.target.closest('.frp__size-btn')); }, options);
      picker.addEventListener('keydown', function (event) {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        var enabled = buttons.filter(function (button) { return button.dataset.available !== 'false'; });
        if (!enabled.length || pending) return;
        event.preventDefault();
        var index = enabled.indexOf(event.target.closest('.frp__size-btn'));
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = enabled.length - 1;
        else index = (index + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1) + enabled.length) % enabled.length;
        enabled[index].focus({ preventScroll: true });
        choose(enabled[index]);
      }, options);
    }
    root.querySelectorAll('[data-frp-open]').forEach(function (link) {
      link.addEventListener('click', function () { var target = document.getElementById(link.hash.slice(1)); if (target) target.open = true; }, options);
    });
    if (stickyButton) stickyButton.addEventListener('click', function () { if (atc && !atc.disabled) atc.click(); }, options);
    if (form && atc) {
      form.addEventListener('submit', function () {
        if (atc.disabled) return;
        pending = true;
        succeeded = false;
        if (status) { status.textContent = ''; status.classList.remove('is-error'); }
        form.setAttribute('aria-busy', 'true');
        updateSticky();
      }, options);
      var buttonObserver = new MutationObserver(function () {
        if (pending && !atc.disabled) {
          pending = false;
          form.setAttribute('aria-busy', 'false');
          if (status) {
            status.textContent = succeeded ? labels.added : labels.failed;
            status.classList.toggle('is-error', !succeeded);
          }
        }
        updateSticky();
      });
      buttonObserver.observe(atc, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      observers.push(buttonObserver);
      document.addEventListener('fr:cart:item-added', function (event) {
        if (!pending || !current || String(event.detail.variantId) !== String(current.id)) return;
        succeeded = true;
        if (status) status.textContent = labels.added;
        updateSticky();
      }, options);
    }
    var bodyObserver = new MutationObserver(schedule);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    observers.push(bodyObserver);
    window.addEventListener('scroll', schedule, { passive: true, signal: controls.signal });
    window.addEventListener('resize', function () { selectImage(active, false); schedule(); }, options);
    document.addEventListener('focusin', schedule, options);
    document.addEventListener('focusout', function () { timers.push(setTimeout(schedule, 0)); }, options);
    window.addEventListener('popstate', function () {
      var id = new URL(location.href).searchParams.get('variant');
      selectVariant(variants.find(function (variant) { return String(variant.id) === id; }) || current, false, true);
    }, options);
    instances.set(root.id, function () {
      controls.abort();
      observers.forEach(function (observer) { observer.disconnect(); });
      timers.forEach(clearTimeout);
      if (frame) cancelAnimationFrame(frame);
      instances.delete(root.id);
      document.body.classList.remove('frp-has-sticky');
    });
    selectVariant(current, false, current && sample(current));
  }
  window.FRProductRefinement = { boot: boot };
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.frp[data-frp-version="7.0"]').forEach(function (root) { if (instances.has(root.id)) instances.get(root.id)(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();

